import {Fabric, PRStatus} from "../models/print.request.models";
import {ReactComponent as InPreparationIcon} from "../assets/icons/InPreparation.svg";
import {ReactComponent as InProdIcon} from "../assets/icons/InProd_1.svg";
import {ReactComponent as ReadyToShipIcon} from "../assets/icons/ReadyToShip.svg";
import {ReactComponent as ShippedIcon} from "../assets/icons/Shipped.svg";
import {IOrderStatus, OrderStatusType} from "../models/order.models";

export const searchStatus = Object.keys(PRStatus).map((k) => k);
export const updateStatuses = Object.keys(PRStatus).filter(
  (k) =>
    k !== PRStatus.Placed && k !== PRStatus.Error && k !== PRStatus.Canceled
);
export const fabric = Object.keys(Fabric).map((k) => k);

export const orderStatus: IOrderStatus[] = [
  {
    title: "orderDetail.statusShipping.inPreparation",
    status: OrderStatusType.InPreparation,
    prStatus: [PRStatus.Placed, PRStatus.TFInDesign, PRStatus.ReadyToPrint, PRStatus.Pulled],
    icon: InPreparationIcon,
  },
  {
    title: "orderDetail.statusShipping.inProduction",
    status: OrderStatusType.InProduction,
    prStatus: [
      PRStatus.Printed,
      PRStatus.Carrefour,
      PRStatus.PrintInProgress,
      PRStatus.ReadyForReprint,
      PRStatus.OnHold,
    ],
    icon: InProdIcon,
  },
  {
    title: "orderDetail.statusShipping.readyToShip",
    status: OrderStatusType.ReadyToShip,
    prStatus: [PRStatus.ShipReady],
    icon: ReadyToShipIcon,
  },
  {
    title: "orderDetail.statusShipping.shipped",
    status: OrderStatusType.Shipped,
    prStatus: [PRStatus.Shipped],
    icon: ShippedIcon,
  }
];

export const prStatusesValue = [
  {
    value: PRStatus.Canceled,
    textValue: "orderDetail.statusShipping.canceled"
  }
]